import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IJanela } from './janela.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JanelaService {
  private apiUrl = `${environment.baseURL}Janela`;

  constructor(private http: HttpClient) { }

  getJanelas(): Observable<IJanela[]> {
    return this.http.get<IJanela[]>(`${this.apiUrl}/GetJanelas`);
  }

  saveJanela(janela: IJanela): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/SaveJanela`, { Janela: janela });
  }

  deleteJanela(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/DeleteJanela?id=${id}`);
  }
}
